import React from "react";
import Router from "next/router";
import asPage from "components/core/as-page";
import Breadcrumbs from "components/core/breadcrumbs";
import Header from "components/core/header";
import HeaderBanner from "components/core/header-banner";
import Layout from "components/core/layout";
import Link from "components/elements/link";
import SVG from "components/elements/svg";
import TextContent from "components/elements/text-content";
import SignInForm from "components/sign-in/sign-in-form";
import onlyLoggedOut from "helpers/access-restrictions/only-logged-out";

class SignIn extends React.Component {
  static getInitialProps({ query, res, user }) {
    if (user && user.id) {
      if (res) {
        res.writeHead(307, { Location: "/my-account/notifications" });
        res.end();
      } else {
        Router.push({
          pathname: "/my-account/notifications",
        });
      }
    }
    return new Promise((resolve) => {
      resolve({ query });
    });
  }

  render() {
    const { query } = this.props;
    return (
      <Layout className="sign-in" title="Sign in">
        <Header>
          <HeaderBanner
            title="Sign in"
            icon="key"
            background="/static/images/header-sign-in.jpg"
          />
        </Header>

        <Breadcrumbs>
          <Breadcrumbs.Item title="Sign in" url="sign-in" />
        </Breadcrumbs>

        <section className="sign-in__content">
          <div className="container">
            <div className="row">
              <div className="col-sm-6 col-left">
                <SignInForm
                  redirect={query.redirect ? query.redirect : undefined}
                />
              </div>

              <div className="col-sm-6 col-right">
                <h2 className="section-heading">Don't have an account yet?</h2>

                <TextContent>
                  <p>
                    <span className="text-medium">
                      Sign up to Hammer Price Homes.
                    </span>
                    <br />
                    You'll be able to choose if you're buyer or seller.
                  </p>

                  <p>
                    Registration is absolutely free and won't take you more than
                    5 minutes.
                  </p>

                  <Link to="register" className="btn btn-secondary with-arrow">
                    <span>Create new account</span>
                    <SVG src="arrow-right" className="arrow" />
                  </Link>
                </TextContent>
              </div>
            </div>
          </div>
        </section>
      </Layout>
    );
  }
}

export default asPage(SignIn, onlyLoggedOut);
